module.exports = __webpack_public_path__ + "static/media/img09.7abfc9c2.png";